export default __webpack_public_path__ + "static/media/BG-Green-0007.3b8e17e1.png";